import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QbExitIntentModalComponent } from '@shared/components/exit-intent-modal/exit-intent-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ExitIntentService {
  private shown = false;

  constructor(private readonly modalCtrl: ModalController) {}

  async showModal(): Promise<boolean> {
    if (this.shown || sessionStorage.getItem('exit-intent-shown')) {
      return false;
    }

    this.shown = true;
    sessionStorage.setItem('exit-intent-shown', 'true');

    const modal = await this.modalCtrl.create({
      component: QbExitIntentModalComponent,
      backdropDismiss: false,
      cssClass: 'custom-exit-modal',
    });

    await modal.present();
    return true;
  }
}
